import React, { FC } from 'react'
import './mass-selection.scss';
import { RadioGroup } from 'devextreme-react/radio-group'
import { VerificationType } from 'enums';

type Props = {
    onValueChanged: (value: VerificationType) => void,
}

type TemperatureSelection = {
    text: string
    value: VerificationType
}

export const MassSelection: FC<Props> = ({ onValueChanged }) => {

    let selectionOptions: TemperatureSelection[] = [
        { text: 'By Temp', value: VerificationType.Temp },
        { text: 'By PO', value: VerificationType.PO },
    ]

    return (
        <div className={'mass-selection-card'}>
            <RadioGroup
                items={selectionOptions}
                displayExpr={'text'}
                valueExpr={'value'}
                itemRender={(itemData) => { return (<div className={'mass-radiobutton'}>{itemData.text}</div>) }}
                onValueChanged={(e: any) => onValueChanged(e.value)}
                layout="horizontal"
            />
        </div>
    )
}